import React from 'react'
import { isNil, truncate } from 'lodash'
import { Pill } from '@/components/pills/Pill'
import { InteractiveTooltip } from '@/components/tooltips/InteractiveTooltip'

export const isOrgUnique = (orgId) => {
  const orgIdInStorage = JSON.parse(localStorage.getItem('balto_org_id'))

  return orgId !== orgIdInStorage
}

export const setOrgIdInLocalStorage = (orgId) => {
  const orgIdString = JSON.stringify(orgId)

  if (orgIdString) {
    localStorage.setItem('balto_org_id', orgIdString)
  }
}

export const formatCustomColumns = (defaultColumns, customColumns, isTableView, isExtraColumns) => {
  // isTableView keeps the audio status column at index 0, but filters out hidden columns

  // for the filtering of the parent columns like (AI Notes,Scores),
  // depending on the variable it will filter out parent/child columns
  if (isNil(defaultColumns)) {
    return []
  }
  const formattedColumns = []
  const lockedColumns = defaultColumns.filter(({ is_locked }) => is_locked)
  const lockedAccessors = lockedColumns.map(({ accessor }) => accessor)

  if (isTableView) {
    lockedColumns.forEach((column) => {
      formattedColumns.push(column)
    })
  }

  let formattedCustomColumns = customColumns
    .map(({ accessor, ...rest }) => {
      const defaultColumn = defaultColumns.find(
        ({ accessor: defaultAccessor }) => defaultAccessor === accessor
      )
      if (isNil(defaultColumn) && isExtraColumns) {
        return {}
      }
      return {
        ...defaultColumn,
        ...rest,
        label: defaultColumn?.label ? defaultColumn.label : rest.label, // in case name of the column is updated
        is_locked: defaultColumn?.is_locked,
        isSearchable: defaultColumn?.isSearchable, // make sure it uses the FE values, not saved
        isSortable: defaultColumn?.isSortable,
      }
    })
    .filter(({ is_locked }) => !is_locked)
  formattedCustomColumns = formattedCustomColumns.filter(({ parent }) =>
    isNil(isExtraColumns) || !isExtraColumns ? !parent : parent
  )

  if (isTableView) {
    formattedCustomColumns = formattedCustomColumns.filter(({ is_hidden }) => !is_hidden)
  }
  const userColumns = formattedColumns.concat(formattedCustomColumns)
  // this covers us if we add more defualt columns in the future
  const missingColumns = defaultColumns.filter(
    ({ accessor }) =>
      !lockedAccessors.includes(accessor) &&
      !customColumns.find(({ accessor: userAccessor }) => userAccessor === accessor)
  )
  return [...userColumns, ...missingColumns].filter((column) => column.accessor)
}

export const truncatedColumn = (value, length = 50) => {
  if (value) {
    return (
      <InteractiveTooltip
        interactive
        block
        content={value}
        placement="top"
        hide={value.length < 50}
      >
        <div>{truncate(value, { length })}</div>
      </InteractiveTooltip>
    )
  }

  return null
}

export const truncatedListColumn = (values) => {
  if (!values) return ''
  const valueArray = values.split(',').map((val) => val.trim())
  if (valueArray.length === 0) return ''
  const firstValue = valueArray[0]
  if (valueArray.length > 1) {
    const remainingCount = valueArray.length - 1
    const allValues = valueArray.join(', ')

    return (
      <div className="flex-align-center flex-space-between gap">
        <span>{firstValue}</span>
        <InteractiveTooltip interactive content={allValues} placement="top-start">
          <Pill small>+{remainingCount} more</Pill>
        </InteractiveTooltip>
      </div>
    )
  }

  return firstValue
}
